export default {
    A1: 1,
    A2: 2,
    A3: 3,
    B1: 4,
    B2: 5,
    C1: 6,
    C2: 7,
    C3: 8,
    C4: 9,
    C5: 10,
    A_BASE: 11,
    ESPECIFICO: 12,
    D1: 13,
}